import { useMutation } from '@tanstack/react-query';
import { useCallback, useRef } from 'react';

import { requestWalletSync, type WalletSyncResponse } from '@/api/wallet/queries';

export const useWalletSyncRequest = () => {
  const requestInFlight = useRef<Promise<WalletSyncResponse> | null>(null);
  const { mutateAsync } = useMutation({ mutationFn: () => requestWalletSync() });

  return useCallback((): Promise<WalletSyncResponse> => {
    if (requestInFlight.current) return requestInFlight.current;

    const request = mutateAsync();
    requestInFlight.current = request;
    const clearRequest = () => {
      if (requestInFlight.current === request) requestInFlight.current = null;
    };
    void request.then(clearRequest, clearRequest);
    return request;
  }, [mutateAsync]);
};
